// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UCDA1Sdmcio8pSMyncdP {
  height: 100vh;
}
.UCDA1Sdmcio8pSMyncdP .kzgS7OKAj4wNgjdsqy2t {
  background-color: #f6f8f9;
  border-right: 1px solid #e5e9eb;
}
.UCDA1Sdmcio8pSMyncdP .ECOFobV4UzH_UnGSz_mj {
  text-align: center;
  padding: 20px 0;
}
.UCDA1Sdmcio8pSMyncdP .UgHm6inXsAYI7GORAtsC {
  height: 56px;
  border-bottom: 1px solid #e5e9eb;
  background-color: #fff;
}
.UCDA1Sdmcio8pSMyncdP .AplobxGhIf2M_ZLORCHF {
  background-color: #fff;
  padding: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/AdminLayout/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;AAAF;AADA;EAII,yBAAA;EACA,+BAAA;AAAJ;AALA;EASI,kBAAA;EACA,eAAA;AADJ;AATA;EAcI,YAAA;EACA,gCAAA;EACA,sBAAA;AAFJ;AAdA;EAoBI,sBAAA;EACA,aAAA;AAHJ","sourcesContent":["\n.container {\n  height: 100vh;\n\n  .sider {\n    background-color: #f6f8f9;\n    border-right: 1px solid #e5e9eb;\n  }\n\n  .logo {\n    text-align: center;\n    padding: 20px 0;\n  }\n\n  .header {\n    height: 56px;\n    border-bottom: 1px solid #e5e9eb;\n    background-color: #fff;\n  }\n\n  .content {\n    background-color: #fff;\n    padding: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UCDA1Sdmcio8pSMyncdP`,
	"sider": `kzgS7OKAj4wNgjdsqy2t`,
	"logo": `ECOFobV4UzH_UnGSz_mj`,
	"header": `UgHm6inXsAYI7GORAtsC`,
	"content": `AplobxGhIf2M_ZLORCHF`
};
export default ___CSS_LOADER_EXPORT___;
